/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */

const variantCarouselOuterWrapper = document.querySelector('.variant-carousel');
const variantCarouselInnerWrapper = document.querySelector('.variant-carousel-container');
const variantCarouselFilter = document.querySelector('.variant-carousel-filter');
const variantCarouselFilterMobileSelect = document.querySelector('.filter-mobile-select');

const variantCarouselNav = document.querySelector(".variant-carousel-navigation");
const variantCarouselScrollBar = variantCarouselNav.querySelector(".variant-carousel-scrollbar");
let variantCarouselScrollBarWidth = variantCarouselScrollBar.offsetWidth;
let navTrackScrollWidth = variantCarouselInnerWrapper.offsetWidth - variantCarouselOuterWrapper.offsetWidth;

function calculateOverflow() {
	variantCarouselInnerWrapper.classList.remove('no-overflow');
	variantCarouselNav.classList.remove('no-overflow');

	variantCarouselScrollBarWidth = variantCarouselScrollBar.offsetWidth;
	navTrackScrollWidth = variantCarouselInnerWrapper.offsetWidth - variantCarouselOuterWrapper.offsetWidth;

	if (variantCarouselInnerWrapper.offsetWidth < variantCarouselOuterWrapper.offsetWidth) {
		variantCarouselInnerWrapper.classList.add('no-overflow');
		variantCarouselNav.classList.add('no-overflow');
	}
}

window.addEventListener("DOMContentLoaded", (event) => {
	calculateOverflow();
});

window.addEventListener("resize", event => {
	calculateOverflow();
});

//make timeline draggable
let clicking = false;
let clickingNav = false;

variantCarouselInnerWrapper.addEventListener("mousedown", () => {
	clicking = true;
});

variantCarouselInnerWrapper.addEventListener("mousemove", event => {
	if (clicking) {
		variantCarouselOuterWrapper.scrollLeft = variantCarouselOuterWrapper.scrollLeft - event.movementX;
		variantCarouselInnerWrapper.classList.add('dragging');
	}
});

document.addEventListener("mouseup", event => {
	clickingNav = false;
	clicking = false;
	variantCarouselInnerWrapper.classList.remove('dragging');
});

// move bottom scrollbar when scrolling carousel
window.addEventListener("resize", event => {
	variantCarouselInnerWrapper.classList.remove('no-overflow');
	variantCarouselNav.classList.remove('no-overflow');

	variantCarouselScrollBarWidth = variantCarouselScrollBar.offsetWidth;
	navTrackScrollWidth = variantCarouselInnerWrapper.offsetWidth - variantCarouselOuterWrapper.offsetWidth;

	if (variantCarouselInnerWrapper.offsetWidth < variantCarouselOuterWrapper.offsetWidth) {
		variantCarouselInnerWrapper.classList.add('no-overflow');
		variantCarouselNav.classList.add('no-overflow');
	}

});

const navCursor = variantCarouselNav.querySelector(".variant-carousel-scrollbar-cursor");

let navTrackScrollProgress = 0;

variantCarouselOuterWrapper.addEventListener('scroll', event => {

	if (!clickingNav) {
		navTrackScrollProgress = event.target.scrollLeft / navTrackScrollWidth;
		const navTrackScrollProgressPx = (navTrackScrollProgress * variantCarouselScrollBarWidth);
		navCursor.style.left = `${navTrackScrollProgressPx}px`;
	}
});


//scroll timeline when dragging bottom scrollbar:
navCursor.addEventListener("mousedown", () => {
	clickingNav = true;
});

navCursor.addEventListener("touchstart", () => {
	clickingNav = true;
});

document.addEventListener("mousemove", event => {
	if (clickingNav) {

		const newPositionNavCursor = navCursor.offsetLeft + event.movementX;

		if (newPositionNavCursor >= 0 && newPositionNavCursor <= variantCarouselScrollBar.offsetWidth) {

			//drag scrollbar 
			navCursor.style.left = `${newPositionNavCursor}px`;

			//scroll timeline
			const navBarPercentage = newPositionNavCursor / variantCarouselScrollBar.offsetWidth;
			const newTimelinePosition = navBarPercentage * navTrackScrollWidth;
			variantCarouselOuterWrapper.scrollLeft = newTimelinePosition;

		}
	}
});

var previousTouch;
let movement;

document.addEventListener("touchmove", event => {
	if (clickingNav) {

		const touch = event.touches[0];

		if (previousTouch) {
			movement = touch.pageX - previousTouch.pageX;
		}

		const newPositionNavCursor = navCursor.offsetLeft + movement;

		if (newPositionNavCursor >= 0 && newPositionNavCursor <= variantCarouselScrollBar.offsetWidth) {

			//drag scrollbar 
			navCursor.style.left = `${newPositionNavCursor}px`;

			//scroll timeline
			const navBarPercentage = newPositionNavCursor / variantCarouselScrollBar.offsetWidth;
			const newTimelinePosition = navBarPercentage * navTrackScrollWidth;
			variantCarouselOuterWrapper.scrollLeft = newTimelinePosition;

		}
	}
});

document.addEventListener("touchend", (e) => {
	previousTouch = null;
	movement = 0;
	clickingNav = false;
	clicking = false;
	variantCarouselInnerWrapper.classList.remove('dragging');
});

//category filtering:

const filterItems = variantCarouselFilter.querySelectorAll('.filter-item');
const variantSlides = variantCarouselInnerWrapper.querySelectorAll('.variant-slide');

function filterByCategory(category) {

	filterItems.forEach(filterItem => {
		filterItem.classList.remove('active');

	});
	const filterItem = variantCarouselFilter.querySelector(`[data-variantcategory="${category}"]`);
	filterItem.classList.add('active');

	[...variantSlides].forEach((variantSlide) => {
		variantSlide.classList.remove('hidden');
	});

	const fliteredOutSlides = [...variantSlides].filter((variantslide) => variantslide.dataset.variantcategory !== category);
	fliteredOutSlides.forEach((fliteredOutSlide) => {
		fliteredOutSlide.classList.add('hidden');
	});

	variantCarouselOuterWrapper.scrollLeft = 0;
	variantCarouselFilterMobileSelect.innerHTML = filterItem.innerHTML;

	calculateOverflow();
}

filterItems.forEach(filterItem => {
	filterItem.addEventListener('click', () => {
		filterByCategory(filterItem.dataset.variantcategory);
		variantCarouselFilter.classList.remove('open');

	})
});

//on load select first captionSide: 

const firstCat = filterItems[0].dataset.variantcategory;
filterByCategory(firstCat);



// mobile type brand filter 
variantCarouselFilterMobileSelect.addEventListener('click', () => {
	if (variantCarouselFilter.classList.contains('open')) {
		variantCarouselFilter.classList.remove('open');
	} else {
		variantCarouselFilter.classList.add('open');
	}
});


/* eslint-enable no-console */
